import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Layout } from '../components/layout/Layout';
import { getHome, getShared } from '../content';
import '../i18n/config';
import Home from '../pages/Home';

document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('home-page');
  if (!container) return;

  const shared = getShared();
  const page = getHome();

  createRoot(container).render(
    <StrictMode>
      <Layout shared={shared}>
        <Home {...page} />
      </Layout>
    </StrictMode>,
  );
});
